<template>
    <div class="grid max-w-2xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.self_certification_form"
            :label="$t('acknowledgements.self_certification_form')"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'self_certification_form')"
            name="acknowledgements.self_certification_form"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement"
            :label="$t('acknowledgements.tax_data_exchange_agreement')"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'tax_data_exchange_agreement')"
            name="acknowledgements.tax_data_exchange_agreement"></BaseInputCheckbox>

        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.report_changes"
            :label="$t('acknowledgements.report_changes')"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'report_changes')"
            name="acknowledgements.report_changes"></BaseInputCheckbox>

        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.complete_and_correct_information"
            :label="$t('acknowledgements.complete_and_correct_information')"
            :required="
                isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'complete_and_correct_information')
            "
            name="acknowledgements.complete_and_correct_information"></BaseInputCheckbox>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import { usePersonalAccountDataState } from '../../../../../utilities/account/useAccountDataPersonal'
import { isRequiredNaturalComplianceProfileAttribute } from '../forms'

const { naturalProfile: account } = usePersonalAccountDataState()
</script>
